/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * Generates unique css safe ids for elements.
 * @param instanceName - the name of the element/instance to keep track of
 * @param map - a Map<string, counter>, which counts how many times the given element/instance was rendered
 * @returns a string in a format `instanceName_intanceRenderedCount`: `Alert_4`
 */
const generateId = (instanceName, map) => {
  if (!map.has(instanceName)) {
    map.set(instanceName, 0);
  } else {
    map.set(instanceName, map.get(instanceName) + 1);
  }
  // Do not rename '___' to '_' it will cause name clash with InstUI v10.14.0
  // or older
  return `${instanceName}___${map.get(instanceName)}`;
};
export default generateId;
export { generateId };